import { render, staticRenderFns } from "./ParamCompare.vue?vue&type=template&id=001c9ab0&scoped=true"
import script from "./ParamCompare.vue?vue&type=script&lang=js"
export * from "./ParamCompare.vue?vue&type=script&lang=js"
import style0 from "./ParamCompare.vue?vue&type=style&index=0&id=001c9ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001c9ab0",
  null
  
)

export default component.exports